import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'duration-input',
    templateUrl: './duration-input.component.html',
    styleUrls: ['./duration-input.component.scss'],
    standalone: false
})
export class DurationInputComponent implements OnInit {

  @Input() parent: Models.IbexBaseModel;
  @Input() key: string;
  @Input() translationPrefix: string;

  constructor() {
  }

  get convertedValue(): string {
    const durationObject: { h?: number, m?: number, s?: number, ms?: number } = {};
    let tempVal = this.parent[this.key];

    if (tempVal >= 1000 * 60 * 60) {
      if (this.parent[this.key] % (1000 * 60 * 60) > 0) {
        tempVal = this.parent[this.key] % (1000 * 60 * 60);
        durationObject.h = (this.parent[this.key] - tempVal) / (1000 * 60 * 60);
      } else {
        durationObject.h = this.parent[this.key] / (1000 * 60 * 60);
        tempVal = 0;
      }
    }

    if (tempVal >= 1000 * 60) {
      if (tempVal % (1000 * 60) > 0) {
        const tempValNew = tempVal % (1000 * 60);
        durationObject.m = (tempVal - tempValNew) / (1000 * 60);
        tempVal = tempValNew;
      } else {
        durationObject.m = tempVal / (1000 * 60);
        tempVal = 0;
      }
    }

    if (tempVal >= 1000) {
      if (tempVal % 1000 > 0) {
        const tempValNew = tempVal % 1000;
        durationObject.s = (tempVal - tempValNew) / 1000;
        tempVal = tempValNew;
      } else {
        durationObject.s = tempVal / 1000;
        tempVal = 0;
      }
    }

    if (tempVal > 0) {
      durationObject.ms = tempVal;
    }

    let durationString = '';
    if (durationObject.h) {
      durationString += durationObject.h + 'h ';
    }
    if (durationObject.m) {
      durationString += durationObject.m + 'm ';
    }
    if (durationObject.s) {
      durationString += durationObject.s + 's ';
    }
    if (durationObject.ms) {
      durationString += durationObject.ms + 'ms ';
    }

    return durationString;
  }

  set convertedValue(value: string) {
    // special component, live data-dual-binding wouldn't work so we do nothing, and the change will be handled by 'onChange'
  }

  ngOnInit() {
  }

  onChange(event: any) {
    const matches = event.currentTarget.value.match(/(\d+[a-z]{1}([a-z]{1})?)/gi) || [];
    let value = 0;
    for (const match of matches) {
      if (!match.endsWith('ms') && !match.endsWith('m') && !match.endsWith('s') && !match.endsWith('h')) {
        console.error('duration format not correct');
        return;
      }
      if (match.endsWith('ms')) {
        value += parseInt(match.substr(0, match.length - 2), 10);
        continue;
      }
      if (match.endsWith('s')) {
        value += parseInt(match.substr(0, match.length - 1), 10) * 1000;
      }
      if (match.endsWith('m')) {
        value += parseInt(match.substr(0, match.length - 1), 10) * (1000 * 60);
      }
      if (match.endsWith('h')) {
        value += parseInt(match.substr(0, match.length - 1), 10) * (1000 * 60 * 60);
      }
    }

    this.parent[this.key] = value;
  }
}
